import { l } from '@manychat/manyui'

import { IBlock, IOtnRequestBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { PreviewConverter } from 'common/builder/components/chart/FlowChart/lib/utils/PreviewConverter'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartSubscribeRequestBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartSubscribeRequestBlock'
import { BlockType } from 'common/builder/constants/BlockType'
import { ReasonTypes } from 'common/oneTimeNotify/constants/notifyReasonConstants'
import { getTypeById } from 'common/oneTimeNotify/selectors/notifyReasonSelectors'
import { getBlockSubtitleByType } from 'common/oneTimeNotify/utils'

export const SubscribeRequestBlockGenericConverterRule: ConverterRule<
  IOtnRequestBlock,
  FlowChartSubscribeRequestBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.ONE_TIME_NOTIFY_REQUEST,
  convert: (entity: IOtnRequestBlock, { state, flowChartButtons }) => {
    const requestReasonType = getTypeById(state, entity.reasonId)
    const isOtn = requestReasonType === ReasonTypes.ONE_TIME
    const reasonSubTitle =
      entity.reasonId && requestReasonType ? getBlockSubtitleByType(requestReasonType) : null

    return {
      id: entity.id,
      type: FlowChartBlockType.SUBSCRIBE_REQUEST,
      data: {
        label: isOtn ? `${l.translate('Get notified')}:` : null,
        title: entity.title || l.translate('Add a title'),
        subTitle: reasonSubTitle || l.translate('Add a subtitle'),
        preview: !isOtn ? PreviewConverter.fromIBlockImage(entity.image) : null,
        buttons: getButtonsFromMap(entity.buttons, flowChartButtons),
      },
    }
  },
}
